import { LowerCasePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslocoPipe } from '@jsverse/transloco';
import { MarketReportRanking } from '../domain';

@Component({
  selector: 'rma-market-report-rankings',
  templateUrl: './market-report-rankings.component.html',
  styleUrls: ['./market-report-rankings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCardModule, NgClass, LowerCasePipe, TranslocoPipe],
})
export class MarketReportRankingsComponent {
  @Input() public rankings: MarketReportRanking[];

  public getRankingColours(ranking: MarketReportRanking) {
    switch (ranking.rankPosition) {
      case 1:
        return 'gold';
      case 2:
        return 'bg-steel-20 text-steel-100';
      case 3:
        return 'bronze';
      default:
        return 'bg-steel-100 text-white';
    }
  }
}
